$(document).on("click",".shipping-protection-toggle-switch input",function() {
  $(this).parent().addClass('shipping-protection-toggle-switch-loading');
  var id = $(this).data('product-id');
  
  if($(this).prop('checked')){
    UpdateCart("/cart/add.js", id, 1);
  }else{
    removeProductById(id);
  }
});

$(document).ready(function() {
  if(document.querySelectorAll('#shipping-protection').length > 0){
    if(!document.querySelector('#shipping-protection').checked){
      document.querySelector('.shipping-protection-toggle-switch input').click();
    }
  }
});

function removeProductById(productId) {
  fetch('/cart.js')
      .then(response => response.json()) // Fetch the cart details
      .then(cart => {
          // Find the line number of the product by its product_id
          const line = cart.items.findIndex(item => item.id === productId) + 1;

          if (line > 0) {
            var remove_product = true;
            UpdateCart("/cart/change.js", line, 0, remove_product);
          } else {
              throw new Error('Product not found in the cart.');
          }
      })
      .then(response => response.json()) // Response from the /cart/change.js
      .then(data => {
          console.log('Product removed:', data);
          updateCartUI(data); // Optionally update the UI after the product is removed
      })
      .catch(error => console.error('Error:', error));
}

function UpdateCart(rount, productId, quantity, remove_product){
  if(remove_product){
    var body = JSON.stringify({
      line: productId,
      quantity: quantity,
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
  }else{
    var body = JSON.stringify({
      id: productId,
      quantity: quantity,
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
  }
  fetch(`${rount}`, {
  method: "POST",
  headers: {
      "Content-Type": "application/json",
    },
    body,
  })
  .then((response) => response.json())
  .then((data) => {
      console.log("Product added:", data);

      // Update the cart drawer
    // var DataSections = data.sections;

    // if (data.sections && data.sections["cart"]) {
    //     // document.querySelector("cart-drawer").innerHTML = data.sections["cart-drawer"];
    //   getSectionsToRender().forEach((section => {
    //     const elementToReplace =
    //       document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
    //     elementToReplace.innerHTML =
    //       getSectionInnerHTML(DataSections[section.section], section.selector);
    //   }));

    // }
    if($('.shipping-protection-toggle-switch-loading').length > 0){
      $('.shipping-protection-toggle-switch-loading').removeClass('shipping-protection-toggle-switch-loading')
    }
    updateCartinfo()
    
  })
  .catch((error) => console.error("Error:", error));
}

function getSectionsToRender(){
  return [
    {
      id: 'cart-js',
      section: 'cart',
      selector: 'form[action="/cart"]'
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '#cart-icon-bubble'
    }
  ];
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

function updateCartinfo(){
  $('.update-cart').click();
  
  // $('.cart').addClass('aos-animate');
  // $('.cart__content').addClass('aos-animate')
  // $('.cart__items').addClass('aos-animate');
  // $('.cart__item').addClass('aos-animate');
  // $('.cart__aside').addClass('aos-animate');
  // $('.section__heading.h2').addClass('aos-animate')
}